import script from "./CourtsSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtsSelection.vue?vue&type=script&setup=true&lang=js"

import "./CourtsSelection.vue?vue&type=style&index=0&id=734ab842&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-734ab842"]])

export default __exports__